<template>
  <v-card class="json-path tools-view-card">
    <ToolbarHeader :name="'JSON Path'"/>
    <v-container>
      <section class="ma-5">
        <v-form
            v-model="formOptions.valid"
            v-on:submit.prevent="formSubmit()"
        >
          <label>
            JSON
          </label>
          <editor
              v-model="form.input"
              @init="initJSONEditor"
              lang="javascript"
              theme="chrome"
              width="100%"
              height="60vh">
          </editor>
          <v-text-field
              v-model="form.jsonPath"
              required
              :rules="formOptions.jsonPath"
              name="Expression"
              label="Expression"
          />
          <v-btn
              :disabled="!formOptions.valid"
              type="submit"
              color="primary"
          >
            Process
          </v-btn>
        </v-form>
        <label class="mt-5">
          Result
        </label>
        <editor
            v-model="JSON_PATH_RESULT"
            theme="chrome"
            @init="initJSONEditor"
            width="100%"
            height="60vh">
        </editor>

      </section>
    </v-container>
  </v-card>
</template>


<script>
import {mapGetters} from "vuex";
import ToolbarHeader from "@/components/Toolbar-Header";
import {aceEditorMixin} from "@/mixins/aceEditorMixin";

const form = {
  input: '{"status":200,"error":"","data":[{"news_id":51184,"title":"iPhone X Review: Innovative future with real black technology","source":"Netease phone"},{"news_id":51183,"title":"Traffic paradise: How to design streets for people and unmanned vehicles in the future?","source":"Netease smart"},{"news_id":51182,"title":"Teslamask\'s American Business Relations: The government does not pay billions to build factories","source":"AI Finance","members":["Daniel","Mike","John"]},{"news_id":51182,"title":"Teslamask\'s American Business Relations: The government does not pay billions to build factories","source":"AI Finance","members":["Daniel","Mike","John"]}, {"news_id":51182,"title":"Teslamask\'s American Business Relations: The government does not pay billions to build factories","source":"AI Finance","members":["Daniel","Mike","John"]}, {"news_id":51182,"title":"Teslamask\'s American Business Relations: The government does not pay billions to build factories","source":"AI Finance","members":["Daniel","Mike","John"]}, {"news_id":51182,"title":"Teslamask\'s American Business Relations: The government does not pay billions to build factories","source":"AI Finance","members":["Daniel","Mike","John"]}, {"news_id":51182,"title":"Teslamask\'s American Business Relations: The government does not pay billions to build factories","source":"AI Finance","members":["Daniel","Mike","John"]}]}',
  jsonPath: '$.data[1].news_id'
};

export default {
  name: "JSON-Path",
  mixins: [aceEditorMixin],
  components: {
    ToolbarHeader
  },
  data: () => ({
    form: Object.assign({}, form),
    formOptions: {
      valid: false,
      input: [
        v => !!v || 'JSON is required',
      ],
      jsonPath: [
        v => !!v || 'Expression is required',
      ],
    }
  }),
  computed: {
    ...mapGetters([
      'JSON_PATH_RESULT',
    ]),
  },
  methods: {
    formSubmit() {
      this.jsonPretty();
      this.$store.dispatch('POST_JSON_PATH', {form: this.form});
    },
    jsonPretty() {
      const parseJSON = JSON.parse(this.form.input);
      this.form.input = JSON.stringify(parseJSON, undefined, 4);
    }
  }
}
</script>
